/* src/app/shared/contract/contract-item/contract-cgrp-on/contract-cgrp-on.component.scss */
.light-flex-card {
  background-color: #FFF;
  border-radius: 10px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  padding: 7px 10px;
  margin-bottom: 20px;
}
.sub-title {
  font: 700 16px FranceTV Brown;
  color: #001A33;
}
.header-item-filters {
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: flex-end;
  height: 30px;
  margin-bottom: 15px;
}
.container {
  position: relative;
  min-height: 64px;
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  align-items: stretch;
  gap: 20px;
  width: 100%;
  box-sizing: border-box;
  padding: 0;
  margin: 0;
  border-radius: 5px;
}
.cgrp-list-loading-overlay {
  position: absolute;
  inset: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: inherit;
  background-color: rgba(255, 255, 255, 0.85);
}
.item {
  display: flex;
  flex-direction: column;
  gap: 15px;
  min-width: 0;
  background-color: rgba(36, 70, 102, 0.05);
  border-radius: 5px;
  padding: 15px;
}
.item-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  font: 400 12px FranceTV Brown;
  background-color: #FFF;
  border-radius: 5px;
  padding: 15px;
}
.item-header {
  display: flex;
  flex: 1;
  min-width: 0;
  justify-content: flex-start;
  align-items: center;
  gap: 10px;
}
.item-header > span {
  color: #001A33;
}
.item-header .title {
  flex: 0 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.item-header .date-range,
.item-header .ca {
  flex-shrink: 0;
  white-space: nowrap;
}
.item-actions {
  display: flex;
  flex-shrink: 0;
  justify-content: flex-end;
  align-items: center;
  gap: 5px;
}
.conditions-container {
  background-color: #FFF;
  padding: 10px;
  border-radius: 5px;
}
.conditions-title {
  margin: 0 0 10px;
  font: 700 12px FranceTV Brown;
  color: #F03C64;
}
.conditions-table-scroll {
  --condition-table-header-height: 36px;
  --condition-table-row-height: 32px;
  max-height: calc(var(--condition-table-header-height) + 5 * var(--condition-table-row-height));
  overflow-y: scroll;
  scrollbar-gutter: stable;
}
.conditions-table {
  width: 100%;
  table-layout: fixed;
}
.conditions-table .mat-mdc-header-row {
  height: var(--condition-table-header-height);
}
.conditions-table .mat-mdc-row {
  height: var(--condition-table-row-height);
}
.conditions-table .mat-mdc-header-cell,
.conditions-table .mat-mdc-cell {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
.conditions-table .mat-mdc-header-cell {
  background-color: #FFF;
}
.conditions-table .mat-column-category {
  width: 27%;
}
.conditions-table .mat-column-number {
  width: 96px;
}
.condition-cell-text {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.conditions-empty-row {
  height: var(--condition-table-row-height);
  font: 400 12px FranceTV Brown;
  color: rgba(0, 26, 51, 0.8);
}
@media (max-width: 1200px) {
  .container {
    grid-template-columns: minmax(0, 1fr);
  }
}
@media (max-width: 600px) {
  .item-header {
    flex-wrap: wrap;
  }
  .item-header .title {
    flex-basis: 100%;
  }
}
.fade-in-right {
  animation: fadeInRight 0.5s forwards;
}
.fade-out-left {
  animation: fadeOutLeft 0.5s forwards;
}
@keyframes fadeInRight {
  from {
    opacity: 0;
    transform: translateX(-100%);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
@keyframes fadeOutLeft {
  from {
    opacity: 1;
    transform: translateX(0);
  }
  to {
    opacity: 0;
    transform: translateX(-100%);
  }
}
.mat-expansion-panel-header {
  height: 58px;
  padding: 0 15px 0 10px;
}
.mat-expansion-indicator {
  background-color: red;
}
.mat-expansion-panel-body {
  padding: 0 0 15px !important;
}
/*# sourceMappingURL=contract-cgrp-on.component.css.map */
